import {webpack_mode} from "Core/lib/webpackMode";

export const devMode = webpack_mode.startsWith("dev");

